import React from 'react'
import splashImage from '../images/Kmart-ErrorMessage-110222-desktop.png'

const Homepage = () => {
    return (
        <>
            <div className="errorbanner-title-holder title-left">
                <h1 className="title1 title1-m">Site down for maintenance</h1>
                <p className="body1 body1-m">We'll be back with you very soon. Thanks for your patience.</p>
            </div>
            <div className="component-t-32"></div>
            <div className="errorbanner-image-holder text-center">
                <img src={splashImage} alt="" />
            </div>
        </>
    )
}

export default Homepage